import React from "react"

import { usePage } from "../../../../hooks/usePage"
import { useCore } from "../../../../hooks/useCore"
import { useCustomerOrders } from "../../../../hooks/useCustomer"
import { useCurrency } from "../../../../hooks/useCurrency"

export const withCustomerOrdersCard = Component => ({ name = "CustomerOrdersCard" }) => {
  const {
    helpers: { decodeShopifyId },
  } = useCore()
  const {
    orders: { additionalOrderNo, additionalDate, additionalStatus, additionalTotalPrice, additionalMore, additionalInTransit, additionalDelivered },
  } = usePage()
  const { formatCurrency } = useCurrency()
  const { orders, loading, error } = useCustomerOrders(10)

  const statusMapping = {
    FULFILLED: additionalDelivered,
    UNFULFILLED: additionalInTransit,
  }

  const orderList = orders?.map(({ node }) => ({
    id: node?.id,
    name: node?.name,
    price: node?.totalPriceV2?.amount ? formatCurrency(Number(node?.totalPriceV2?.amount), node?.currencyCode, 2) : "",
    currency: node?.currencyCode,
    fulfillmentStatus: statusMapping[node?.fulfillmentStatus] ? statusMapping[node?.fulfillmentStatus] : node?.fulfillmentStatus,
    url: node?.statusUrl,
    date: node?.processedAt
      ? new Intl.DateTimeFormat("en-AU", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          timeZone: "Australia/Melbourne",
        }).format(Date.parse(node?.processedAt))
      : "",
    link: `/account/orders/${decodeShopifyId(node?.id, "Order")}`,
    lineItems: node?.lineItems?.edges?.map(edge => ({
      quantity: edge.node?.quantity,
      title: edge.node?.title,
      discountedTotalPrice: edge.node?.discountedTotalPrice,
      variant: {
        title: edge.node?.variant?.title,
        image: edge.node?.variant?.image,
        id: edge.node?.variant?.id,
      },
    })),
  }))

  Component.displayName = name
  return (
    <Component
      orders={orderList}
      loading={loading}
      error={error}
      additionalOrderNo={additionalOrderNo}
      additionalDate={additionalDate}
      additionalStatus={additionalStatus}
      additionalTotalPrice={additionalTotalPrice}
      additionalMore={additionalMore}
    />
  )
}
